import { apiCall, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import {
  deleteNotificationMock,
  getNewsletterBaseTemplateMock,
  newsletterDetailsMock,
  newsletterGetMock,
  readNotificationMock,
  successMock,
} from './mock';
import { parseQueryParams } from '../../utils/queryParams';
import { newsletterPath } from '../../utils/paths';

export default {
  getNewsletter: (filters) => {
    if (shouldUseMock()) {
      return newsletterGetMock(filters);
    }
    return apiCall(
      `${baseUrl}${newsletterPath}newsletters/list${parseQueryParams(filters)}`,
      'GET'
    );
  },
  newsletterRead: (params) => {
    if (shouldUseMock()) {
      return readNotificationMock();
    }
    return apiCall(
      `${baseUrl}${newsletterPath}newsletters/status`,
      'POST',
      params
    );
  },
  newsletterDelete: (params) => {
    if (shouldUseMock()) {
      return deleteNotificationMock();
    }
    return apiCall(
      `${baseUrl}${newsletterPath}newsletters/delete`,
      'POST',
      params
    );
  },
  newsletterDetailsGet: (id) => {
    if (shouldUseMock()) {
      return newsletterDetailsMock();
    }
    return apiCall(`${baseUrl}${newsletterPath}${id}/details`, 'GET');
  },
  newsletterSend: (body) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(`${baseUrl}${newsletterPath}send`, 'POST', body);
  },
  newsletterBaseTemplateGet: () => {
    if (shouldUseMock()) {
      return getNewsletterBaseTemplateMock();
    }
    return apiCall(`${baseUrl}${newsletterPath}template`, 'GET');
  },
};
